"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefillList = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const dataview_1 = require("primereact/dataview");
const ListItemSkeleton_1 = require("../../products/mobile/ListItemSkeleton");
const ListItem_1 = require("./ListItem");
const progressspinner_1 = require("primereact/progressspinner");
const editor_module_scss_1 = __importDefault(require("../../products/mobile/editor.module.scss"));
const FiltersComponent_1 = require("../../../components/filter/FiltersComponent");
const react_i18next_1 = require("react-i18next");
const RefillList = ({ refills, globalFilterValue, onGlobalFilterChange, fetchData, loading, pagination, handlerDateFilter, dateFilter, resetPageToFirst, ids, onMachineIdChange, }) => {
    const observerRef = (0, react_1.useRef)(null);
    const { t } = (0, react_i18next_1.useTranslation)();
    const loadMore = (0, react_1.useCallback)(() => {
        if (!pagination || !fetchData)
            return;
        if (!loading && pagination.currentPage < pagination.totalPages) {
            fetchData(pagination.currentPage + 1, pagination.pageSize, true);
        }
    }, [loading, pagination, fetchData]);
    (0, react_1.useEffect)(() => {
        const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                loadMore();
            }
        }, { threshold: 0.99 });
        if (observerRef.current) {
            observer.observe(observerRef.current);
        }
        return () => {
            if (observerRef.current) {
                observer.unobserve(observerRef.current);
            }
        };
    }, [loadMore]);
    return ((0, jsx_runtime_1.jsxs)("div", { className: "overflow-auto flex-1", style: { paddingTop: '185px' }, children: [(0, jsx_runtime_1.jsx)(dataview_1.DataView, { value: loading && refills && refills?.length <= 0
                    ? Array(10).fill({})
                    : refills, style: { marginBottom: '80px' }, emptyMessage: t('noRecords'), header: header(globalFilterValue, onGlobalFilterChange, handlerDateFilter, resetPageToFirst, ids, onMachineIdChange), itemTemplate: (p) => loading && refills && refills?.length <= 0 ? ((0, jsx_runtime_1.jsx)(ListItemSkeleton_1.ListItemSkeleton, {})) : ((0, jsx_runtime_1.jsx)(ListItem_1.ListItem, { refill: p, globalFilterValue: globalFilterValue, dateFilter: dateFilter })) }), (0, jsx_runtime_1.jsx)("div", { ref: observerRef, style: { height: '1px' } }), loading && refills && refills?.length > 0 && ((0, jsx_runtime_1.jsx)("div", { className: "loading-spinner", children: (0, jsx_runtime_1.jsx)(progressspinner_1.ProgressSpinner, { style: { width: '25px', height: '25px' }, strokeWidth: "6", fill: "var(--surface-ground)", animationDuration: ".5s" }) }))] }));
};
exports.RefillList = RefillList;
const header = (globalFilterValue, onGlobalFilterChange, handlerDateFilter, resetPageToFirst, ids, onMachineIdChange) => {
    return ((0, jsx_runtime_1.jsx)("div", { style: { backgroundColor: 'rgb(231,238,248)' }, className: "shadow-md", children: (0, jsx_runtime_1.jsx)("div", { className: "w-full flex justify-between items-center", children: (0, jsx_runtime_1.jsx)("div", { className: editor_module_scss_1.default.buttonTopContainer, children: (0, jsx_runtime_1.jsx)(FiltersComponent_1.FiltersComponent, { globalFilterValue: globalFilterValue ?? '', onGlobalFilterChange: onGlobalFilterChange ?? (() => { }), handlerDateFilter: handlerDateFilter, resetPageToFirst: resetPageToFirst, ids: ids, onMachineIdChange: onMachineIdChange, machineId: globalFilterValue ?? '' }) }) }) }));
};
